module.exports = __webpack_public_path__ + "images/emoji/hospital.41bb5c9716a1618ccd67.png";